<template>
    <SimpleButton class="px-3 py-1 text-xs font-medium uppercase" :disabled="disabled" @click="emit('click')">{{props.label}} <Countdown :start="props.start" :duration-seconds="props.durationSeconds" @completed="disabled = true" /></SimpleButton>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import Countdown from '~/components/Countdown.vue'

const emit = defineEmits(['click', 'completed'])
const disabled = ref(false)

const props = defineProps<{
  label?: string
  start?: string
  durationSeconds?: number
}>()
</script>
